import React from 'react';
import Home from './pages';
import CommentList from './pages/commentList';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import NoMatch from './pages/NoMatch';
import Nav from './layouts/Nav';
import { Button } from 'antd';

import "antd/dist/antd.css";
import './App.less';

function App() {
  return (
    <>
      <Nav />
      {/* tslint:disable jsx-no-lambda */}
      <main role="main" className="container" style={{ paddingTop: 50, maxWidth: 700 }}>

        <div className="contents nanummyeongjo">
        <BrowserRouter>
        <Switch>
          <Route exact={true} path="/" render={() => <CommentList />} />
          <Route exact={true} path="/proposal" render={() => <Home />} />
          <Route render={() => <NoMatch />} />
          </Switch>

        </BrowserRouter>
        </div>
        <div style={{height: 200}}></div>

      </main>
        
    </>
  );
}

export default App;
